import {useEffect, useState} from 'react';
import {useEvent} from './use-event';

export function useDebounce<ValueType = string>(
  value: ValueType,
  delayMs = 1000,
  handleChange?: (value: ValueType) => void,
): [ValueType, (value: ValueType) => void] {
  const onChange = useEvent(handleChange);
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delayMs]);

  useEffect(() => {
    onChange?.(debouncedValue);
  }, [debouncedValue, onChange]);

  return [debouncedValue, setDebouncedValue];
}
